import React, { Component, useEffect } from "react";
import { Route } from "react-router-dom";
import { Redirect } from "react-router";
import { render } from "react-router-dom";
import swal from "sweetalert";
import { useHCustomization } from "../../../context";

function ProtectedRoute({ component: Component, ...rest }) {
  const { isAuth, setIsAuth } = useHCustomization();
  // useEffect(() => {
  //   setIsAuth(localStorage.getItem('auth'));
  // }, [isAuth]);
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default ProtectedRoute;
